import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SkuDataService } from 'src/app/services/sku-data.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import * as moment from 'moment';
import { SubjectService } from 'src/app/services/subject.service';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';
import { TranslateService } from '@ngx-translate/core';
import { AppSettings } from 'src/app/enums/app-settings.enum';
import { AccountService } from 'src/app/services/account.service';
import { environment } from 'src/environments/environment';
import { ErrorComponent } from '../error/error.component';
import { ApplicationInitializationService } from 'src/app/services/application-initialization.service';
import { ActivatedRoute } from '@angular/router';
import { LearnMoreTravelInsuranceComponent } from '../learn-more-travel-insurance/learn-more-travel-insurance.component';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss'],
})
export class SuccessComponent implements OnInit {
  @Input('data') data: any;
  currentLanguage: string = '';
  preferredNumberMessage: any;
  sku: any;
  transactionId: any;
  mobileNumber: any;
  billType: any;
  price: any;
  addonType: any;
  skuAddonDetails: any;
  orderCompleted: boolean = false;
  isTravelInsuranceAddon:boolean = false;
  isArabic: boolean = false;
  isError: boolean = false;
  isPDPAllowed: boolean = false;
  isFreeParentalEligible: boolean = false;
  userLoggedIn:boolean= false
  accountdetails;
  ENV: any;
  ShowHeader = false
  OrderConfirm = 'CONFIRM_SUBSCRIPTION'
  constructor(
    private modalController: ModalController,
    private UTS: UtilitiesService,
    private SKUDS: SkuDataService,
    private SS: SubjectService,
    private GAS: GoogleAnalyticsService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private AS: AccountService,
    private appInitService: ApplicationInitializationService,
    private aRoute: ActivatedRoute
  ) {
    this.SS.addonBuySuccessfully.subscribe((r) => {
      if (r && r.success == true) {
        const data = r.data;
        if (data && data.transactionNo) this.transactionId = data.transactionNo;
      }
      if (r && r.mobileNumber) {
        this.mobileNumber = r.mobileNumber;
      }
      if (r && r.billType) {
        this.billType = r.billType;
      }
      if (r && r.price) {
        this.price = r.price;
      }
      if (r && r.addonType) {
        this.addonType = r.addonType;
      }
    });
    this.SS.skuDetails.subscribe((sku) => {
      if(sku){
        this.isPDPAllowed =sku && sku?.isPDPAllowed ? sku?.isPDPAllowed: false;
       }
    })
  }

  ngOnInit() {
    this.aRoute.queryParams.subscribe((q) => {
      if (q && q.env) {
        this.UTS.setENV(q.env);
        this.ENV = q.env;
      } else {
        this.ENV = this.UTS.getENV();
      }
    });
    this.ShowHeader = this.appInitService?.environmentConfig?.ENABLE_ADDONS_SUBSCRIPTION_NEW_FLOW == 'TRUE' ? true : false 
    this.currentLanguage = this.UTS.getLocaleLanguage();
    this.sku = this.SKUDS.get();
    if(localStorage.getItem('isRoaming')!==null)
    {
      this.onPurchaseImpression();

    }
    this.SS.currentAccount.subscribe(numberdetails=>{
      if(numberdetails){
        this.accountdetails = numberdetails;
        this.mobileNumber = this.accountdetails?.accountNo 
      }
    })
    this.AS.UserInfo().subscribe(
      (r: any) => {
        if (r) {
          this.userLoggedIn = true;
        }
      },
    );
    this.isFreeParentalEligible = this.data?.isFreeParentalEligible ?? false;
    this.isTravelInsuranceAddon = JSON.parse(localStorage.getItem('isTravelInsuranceAddon')) ?? false;
    this.isArabic = localStorage.getItem('language') !== 'en';
    this.skuAddonDetails = localStorage.getItem('skuAddonDetails') && localStorage.getItem('skuAddonDetails')!=='undefined' ? JSON.parse(localStorage.getItem('skuAddonDetails')) : {};
    
  }
  onPurchaseImpression()
  {
    let product=[{
      name: this.sku?.displayName,
      id:  this.sku?.id ? this.sku.id : this.sku.skuId ? this.sku.skuId : '',
      price: +this.sku?.listPrice,
      brand:this.sku?.brand,
      category:'Roaming',
      user_env:this.UTS.getENV(),
      variant:'black',
      quantity:1
    }];

    let modal_data={
      event:'purchase',
      user_env: this.UTS.getENV(),
      ecommerce:{
        purchase:{
          actionField:{id:'', affiliation:'',
          tax:'',
         revenue:'',
       shipping:'',
     coupon:''},
         products:product
        }
       
      }
    }
    this.GAS.productClick_RoamingType(modal_data);
  }
  ok() {
    this.dismiss();
  }

  cancel() {
    this.dismiss();
  }

  closePopUpEN() {
    this.dismiss();
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    // this.SS.resetVerification.next(true)
    this.modalController.dismiss({
      dismissed: true,
    });
  }

  letGoPopUpLinkEN() {
    const browserName = this.getBrowserInfo();

    var feedbackHost =
      'https://feedback.etisalat.ae/collection/collection.aspx?cguid=9e4-b515de8da5e0&langid=1&sessionCustomText5=&sessionCustomText6=&consumerAccount=&sessionCustomText8=' +
      browserName +
      '&sessionCustomText9=WEB';
    window.open(feedbackHost, '_blank');
  }

  closePopUpAR() {
    this.dismiss();
  }

  letGoPopUpLinkAR() {
    const browserName = this.getBrowserInfo();

    const feedbackHost =
      'https://feedback.etisalat.ae/collection/collection.aspx?cguid=9e4-b515de8da5e0&langid=22&sessionCustomText5=&sessionCustomText6=&consumerAccount=&sessionCustomText8=' +
      browserName +
      '&sessionCustomText9=WEB';
    window.open(feedbackHost, '_blank');
  }

  getBrowserInfo() {
    const nVer = navigator.appVersion;
    const nAgt = navigator.userAgent;
    let browserName = navigator.appName;
    let fullVersion = '' + parseFloat(navigator.appVersion);
    let majorVersion = parseInt(navigator.appVersion, 10);
    let nameOffset, verOffset, ix;

    // In Opera, the true version is after "Opera" or after "Version"
    if ((verOffset = nAgt.indexOf('Opera')) != -1) {
      browserName = 'Opera';
      fullVersion = nAgt.substring(verOffset + 6);
      if ((verOffset = nAgt.indexOf('Version')) != -1)
        fullVersion = nAgt.substring(verOffset + 8);
    }
    // In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
      browserName = 'Microsoft Internet Explorer';
      fullVersion = nAgt.substring(verOffset + 5);
    }
    // In Chrome, the true version is after "Chrome"
    else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
      browserName = 'Chrome';
      fullVersion = nAgt.substring(verOffset + 7);
    }
    // In Safari, the true version is after "Safari" or after "Version"
    else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
      browserName = 'Safari';
      fullVersion = nAgt.substring(verOffset + 7);
      if ((verOffset = nAgt.indexOf('Version')) != -1)
        fullVersion = nAgt.substring(verOffset + 8);
    }
    // In Firefox, the true version is after "Firefox"
    else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
      browserName = 'Firefox';
      fullVersion = nAgt.substring(verOffset + 8);
    }
    // In most other browsers, "name/version" is at the end of userAgent
    else if (
      (nameOffset = nAgt.lastIndexOf(' ') + 1) <
      (verOffset = nAgt.lastIndexOf('/'))
    ) {
      browserName = nAgt.substring(nameOffset, verOffset);
      fullVersion = nAgt.substring(verOffset + 1);
      if (browserName.toLowerCase() == browserName.toUpperCase()) {
        browserName = navigator.appName;
      }
    }

    // trim the fullVersion string at semicolon/space if present
    if ((ix = fullVersion.indexOf(';')) != -1)
      fullVersion = fullVersion.substring(0, ix);
    if ((ix = fullVersion.indexOf(' ')) != -1)
      fullVersion = fullVersion.substring(0, ix);

    majorVersion = parseInt('' + fullVersion, 10);
    if (isNaN(majorVersion)) {
      fullVersion = '' + parseFloat(navigator.appVersion);
      majorVersion = parseInt(navigator.appVersion, 10);
    }

    return browserName;
  }

  getValidity(v: any) {
    if (v) {
      return v == 'Monthly' ? ' 1 Month ' : v == 'Weekly' ? '1 Week' : '1 Day';
    }
    return v;
  }
  today() {
    const lang = this.UTS.getLocaleLanguage();
    if (lang == 'ar') {
      moment.locale('ar-sa');
      return moment(Date.now()).format('Do MMM, YYYY');
    } else {
      moment.locale('en');
      return moment(Date.now()).format('Do MMM, YYYY'); // 13th April, 2020
    }
  }
  completeAddonPurchase(){
    let isLoggedInSubscribe = JSON.parse(localStorage.getItem('isLoggedInSubscribe')) || false;
    let skuAddonDetails = localStorage.getItem('skuAddonDetails') ? JSON.parse(localStorage.getItem('skuAddonDetails')) : null;
    let travelInsurancePayload = localStorage.getItem('travelInsuranceAddonPayload') ? JSON.parse(localStorage.getItem('travelInsuranceAddonPayload')): null;
    if(travelInsurancePayload ){
      if(!isLoggedInSubscribe){
        travelInsurancePayload['token'] = localStorage.getItem('travelInsuranceToken') ?? null;
        travelInsurancePayload['isAdditionalAddonSubscription'] = true;
      }
      
      let URL = isLoggedInSubscribe ? '/addAddonsLoggedIn':'/addAddons'
      

      if(skuAddonDetails !== null){
        travelInsurancePayload['addonId'] = skuAddonDetails?.skus[0]?.skuId || 0;
      }
      this.SKUDS.addAddons(travelInsurancePayload, URL).subscribe((response:any) => {
        if (response) {
          if (response.success == true || response.success == 'true') {
            this.orderCompleted = true;
            this.cdr.detectChanges();
          } else if (response.reason) {
            this.UTS.error(response.reason);
          } else {
            this.UTS.error(AppSettings.ERROR);
          }
        }
      },
      (e) => {
        this.isError = true;
        let eMessage = '';
        if (this.UTS.getLocaleLanguage() == 'en') {
          if (
            e.error.errorDescription == AppSettings.ERROR_RTF_VAL_00015 ||
            e.error.errorDescription == AppSettings.ERROR_VAL_00015
          ) {
            this.translate.get('ERROR_VAL_00015').subscribe((message) => {
              //   this.UTS.error(message);
              eMessage = message;
            });
          }
          else if (
            e.error.errorDescription == AppSettings.ERROR_VAL_00011 ||
            e.error.message == AppSettings.ERROR_VAL_00011 ||
            e.error.message == AppSettings.ERROR_VAL_00002 ||
            e.error.errorDescription == AppSettings.ERROR_VAL_00002
          ) {
            this.translate.get('ERROR_VAL_00011').subscribe((message) => {
              eMessage = message;
            });
          } else if (
            (e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_00011)) ||
            (e.error && e.error.message && e.error.message.includes(AppSettings.VAL_00011)) ||
            (e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_EAQTY)) ||
            (e.error && e.error.message && e.error.message.includes(AppSettings.VAL_EAQTY)) ||
            (e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_00061)) ||
            (e.error && e.error.message && e.error.message.includes(AppSettings.VAL_00061)) ||
            (e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_00133)) ||
            (e.error && e.error.message && e.error.message.includes(AppSettings.VAL_00133)) ||
            (e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_00013)) ||
            (e.error && e.error.message && e.error.message.includes(AppSettings.VAL_00013))
          ) {
            this.translate.get('ERROR_VAL_00011').subscribe((message) => {
              eMessage = message;
            });
          }
          else {
            eMessage = e.error.errorDescription;
            //   this.UTS.error(e.error.errorDescription);
          }
        } else {
          if (e.error.errorDescription == AppSettings.ERROR_VAL_00015) {
            this.translate.get('ERROR_VAL_00015').subscribe((message) => {
              //  this.UTS.error(message);
              eMessage = message;
            });
          }
          else if (
            e.error.errorDescription == AppSettings.ERROR_VAL_00011 ||
            e.error.message == AppSettings.ERROR_VAL_00011 ||
            e.error.message == AppSettings.ERROR_VAL_00002 ||
            e.error.errorDescription == AppSettings.ERROR_VAL_00002
          ) {
            this.translate.get('ERROR_VAL_00011').subscribe((message) => {
              eMessage = message;
            });
          }
          else if (
            (e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_00011)) ||
            (e.error && e.error.message && e.error.message.includes(AppSettings.VAL_00011)) ||
            (e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_EAQTY)) ||
            (e.error && e.error.message && e.error.message.includes(AppSettings.VAL_EAQTY)) ||
            (e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_00061)) ||
            (e.error && e.error.message && e.error.message.includes(AppSettings.VAL_00061)) ||
            (e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_00133)) ||
            (e.error && e.error.message && e.error.message.includes(AppSettings.VAL_00133)) ||
            (e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_00013)) ||
            (e.error && e.error.message && e.error.message.includes(AppSettings.VAL_00013))
          ) {
            this.translate.get('ERROR_VAL_00011').subscribe((message) => {
              eMessage = message;
            });
          } else {
            eMessage = e.error.errorDescriptionAr;
            //   this.UTS.error(e.error.errorDescriptionAr);
          }
        }
        this.openBottomSheet(ErrorComponent, eMessage)
        this.SS.addonBuyError.next(eMessage);
        this.SS.addonBuySuccessfully.next({ success: false, data: e });
      })
    }
  }
  gotTOAddons(){
    const OS = this.UTS.getMobileOperatingSystem();
    this.ENV = this.UTS.getENV();
    if (this.ENV == 'mobile') {
      if (OS == 'Android') {
        (window as any).deals.goBack();
      } else {
        (window as any).webkit.messageHandlers.hybridInterface.postMessage('goBack');
      }
    }else{
      window.location.href =environment.HOST + `/b2c/addon/addonsApp/addons?locale=${this.currentLanguage}`;
    }
      
  }
  gotoSubscribeAddon(){
    const OS = this.UTS.getMobileOperatingSystem();
    this.ENV = this.UTS.getENV();
    if (this.ENV == 'mobile') {
      if (OS == 'Android') {
        const payload = JSON.stringify({ accountNumber: this.mobileNumber });
        (window as any).deals.gotoSubscribeAddonPage(payload);
      } else {
        const messgeToPost = {
          method: 'gotoSubscribeAddonPage',
          accountNumber: this.mobileNumber,
        };
        const passData: string = JSON.stringify(messgeToPost);
        (
          window as any
        ).webkit.messageHandlers.hybridInterface.postMessage(passData)
      }
    }else{
      window.location.href =environment.HOST + `/ecare/d/account-services/manage-extras`;
    }
  }
  moreDetails(){
    const OS = this.UTS.getMobileOperatingSystem();
    this.ENV = this.UTS.getENV();
    if (this.ENV == 'mobile') {
      window.location.href =environment.HOST + `/b2c/addon/addonsApp/addon/detail?skuId=${this.skuAddonDetails?.skus[0]?.skuId}&lang=${this.currentLanguage}&env=mobile`;
    }else{
      window.location.href =environment.HOST + `/b2c/addon/addonsApp/addon/detail?skuId=${this.skuAddonDetails?.skus[0]?.skuId}&lang=${this.currentLanguage}`;
    }
  }
  public async openBottomSheet(
    component: any,
    data,
    classes = 'verification-modal modal-fullscreen'
  ) {
    const modal = await this.modalController.create({
      component: component,
      showBackdrop: true,
      componentProps: { data: data },
      // mode: "ios",
      cssClass: classes,
    });
    return await modal.present();
  }


  async openLearnMoreBottomSheet() {
    let URL = this.isArabic ? this.skuAddonDetails?.skus[0]?.learnMoreAr : this.skuAddonDetails?.skus[0]?.learnMoreEn;

    let payload = {
      URL, flag: 'learnMore'
    };
    const modal = await this.modalController.create({
      component: LearnMoreTravelInsuranceComponent,
      showBackdrop: true,
      backdropDismiss: true,
      cssClass: 'verification-modal modal-fullscreen ion-modal-uplift eand-partail-height-screen-bottom-70-mobile',
      componentProps: { data: payload },
    });
    return await modal.present();
  }

}
